import InputContainer from './InputContainer';
import { useEffect } from 'react';

const SelectOptgroup = ({
    className,
    label,
    id,
    options,
    value,
    onChange,
    inputClassName,
}) => {
    return (
        <InputContainer className={className} label={label} id={id}>
            <select
                value={value}
                onChange={e => onChange(e.target.value)}
                className={inputClassName}
            >
                {options.map(({ label, options }, idx) => (
                    <optgroup key={idx} label={label}>
                        {Object.keys(options).map(k => (
                            <option value={k} key={k}>
                                {options[k]}
                            </option>
                        ))}
                    </optgroup>
                ))}
            </select>
        </InputContainer>
    );
};

export default SelectOptgroup;
